export default __webpack_public_path__ + "chevron-mobile-iNk.svg";